import { html } from "lit";

export const Template = () => {
    return html`
        <footer class="ux-iws-footer">
            <div class="ux-t-container">
                <div class="ux-iws-footer__links-block">
                    <div class="ux-iws-footer__icons-wrapper">
                        <div class="ux-iws-footer__icon-container">
                            <a class="ux-iws-footer__icon-link" href="#">
                                <ux-icon name="avatar"></ux-icon>
                                <span
                                    class="ux-iws-footer__icon-text ux-text-tiny ux-text-tiny--bold"
                                >
                                    Kontakt
                                </span>
                            </a>
                        </div>
                        <div class="ux-iws-footer__icon-container">
                            <a class="ux-iws-footer__icon-link" href="#">
                                <ux-icon name="press"></ux-icon>
                                <span
                                    class="ux-iws-footer__icon-text ux-text-tiny ux-text-tiny--bold"
                                >
                                    Pressebereich
                                </span>
                            </a>
                        </div>
                        <div class="ux-iws-footer__icon-container">
                            <a class="ux-iws-footer__icon-link" href="#">
                                <ux-icon name="calendar"></ux-icon>
                                <span
                                    class="ux-iws-footer__icon-text ux-text-tiny ux-text-tiny--bold"
                                >
                                    Veranstaltungen und Termine
                                </span>
                            </a>
                        </div>
                        <div class="ux-iws-footer__icon-container">
                            <a class="ux-iws-footer__icon-link" href="#">
                                <ux-icon name="mail-open"></ux-icon>
                                <span
                                    class="ux-iws-footer__icon-text ux-text-tiny ux-text-tiny--bold"
                                >
                                    TRUMPF Newsletteranmeldung
                                </span>
                            </a>
                        </div>
                    </div>
                    <div class="ux-iws-footer__scroll-top-wrapper">
                        <ux-scroll-to-top-button
                            square
                        ></ux-scroll-to-top-button>
                    </div>
                    <div
                        class="ux-iws-footer__links-wrapper ux-text-tiny ux-u-text-uppercase"
                    >
                        <div class="ux-iws-footer__link-group">
                            <ux-accordion no-accordion-from="768">
                                <div
                                    slot="title"
                                    class="ux-iws-footer__accordion-title ux-text-tiny ux-text-tiny--bold"
                                >
                                    Online services
                                </div>
                                <ul>
                                    <li>
                                        <a href="#">
                                            <span>
                                                Software TruTops Boost
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                TruBend Serie 5000
                                            </span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#">
                                            <span>
                                                TruMark 5010 Mobile Marker
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                TruLaser Robot 5020
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                TruBend Center
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </ux-accordion>
                        </div>
                        <div class="ux-iws-footer__link-group">
                            <ux-accordion no-accordion-from="768">
                                <div
                                    slot="title"
                                    class="ux-iws-footer__accordion-title ux-text-tiny ux-text-tiny--bold"
                                >
                                    Produkte
                                </div>
                                <ul>
                                    <li>
                                        <a href="#">
                                            <span>
                                                wekzeugmaschinen
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                elektrowerkzeuge
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                lasertechnik
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                elektronik
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </ux-accordion>
                        </div>
                        <div class="ux-iws-footer__link-group">
                            <ux-accordion no-accordion-from="768">
                                <div
                                    slot="title"
                                    class="ux-iws-footer__accordion-title ux-text-tiny ux-text-tiny--bold"
                                >
                                    Unternehmen
                                </div>
                                <ul>
                                    <li>
                                        <a href="#">
                                            <span>
                                                financial leaser
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                operate leasing
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                hire purchase
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                investitionskredit
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                factoring
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </ux-accordion>
                        </div>
                        <div class="ux-iws-footer__link-group">
                            <ux-accordion no-accordion-from="768">
                                <div
                                    slot="title"
                                    class="ux-iws-footer__accordion-title ux-text-tiny ux-text-tiny--bold"
                                >
                                    Verantwortung
                                </div>
                                <ul>
                                    <li>
                                        <a href="#">
                                            <span>
                                                trumpf als arbeitgeber
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                fach- und führungskräfte
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                absolventen und studierende
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                schüler
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <span>
                                                stellenangebote
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </ux-accordion>
                        </div>
                    </div>
                </div>
                <div class="ux-iws-footer__separator">
                    <hr />
                </div>
                <div class="ux-iws-footer__social-icons">
                    <a
                        href="#"
                        aria-label="zum Trumpf X Account"
                        role="button"
                        class="ux-button ux-button--icon-only"
                    >
                        <ux-icon name="social-x"></ux-icon>
                    </a>
                    <a
                        href="#"
                        aria-label="zum Trumpf Facebook Account"
                        role="button"
                        class="ux-button ux-button--icon-only"
                    >
                        <ux-icon name="social-facebook"></ux-icon>
                    </a>
                    <a
                        href="#"
                        aria-label="zum Trumpf Google Plus Account"
                        role="button"
                        class="ux-button ux-button--icon-only"
                    >
                        <ux-icon name="social-google-plus"></ux-icon>
                    </a>
                    <a
                        href="#"
                        aria-label="zum Trumpf Youtube Account"
                        role="button"
                        class="ux-button ux-button--icon-only"
                    >
                        <ux-icon name="social-youtube"></ux-icon>
                    </a>
                    <a
                        href="#"
                        aria-label="zum Trumpf Instagram Account"
                        role="button"
                        class="ux-button ux-button--icon-only"
                    >
                        <ux-icon name="social-instagram"></ux-icon>
                    </a>
                    <a
                        href="#"
                        aria-label="zum Trumpf Kununu Account"
                        role="button"
                        class="ux-button ux-button--icon-only"
                    >
                        <ux-icon name="social-kununu"></ux-icon>
                    </a>
                </div>
                <ul class="ux-text-tiny ux-iws-footer__bottom-links">
                    <li><a href="#">Datenschutz</a></li>
                    <li><a href="#">Impressum</a></li>
                    <li><a href="#">Copyright und Markenrecht</a></li>
                    <li>
                        <a href="#" data-ux-cookie-layer="settings">
                            Privatsphäre-Einstellungen
                        </a>
                    </li>
                </ul>
                <div class="ux-u-text-align--center ux-u-mt-xxs">
                    <p class="ux-text-tiny ux-u-text-uppercase">
                        &copy; 2017 Trumpf
                    </p>
                </div>
            </div>
        </footer>
    `;
};
